<template>
    <v-touch id="app"
             @swipeleft="toggleSwipeSidebar('left')"
             @swiperight="toggleSwipeSidebar('right')">
        <sidebar :show="selectedLeftSidebar"
                 side="left">
            <div id="left-menu">
                <router-link to="/ideas/" style="display: block;">
                    <img src="/static/logo.png" style="width: 200px;">
                </router-link>
                <div class="search-block">
                    <div class="header-search">
                        <button class="button-search" @click="goToSearch(enteredSearchString)">
                            <i class="ti-search"></i>
                        </button>
                        <input type="search" name="search" class="searsh"
                               placeholder="Начать поиск"
                               @blur="enterSearchString($event.target.value)"
                               @keyup.enter="goToSearch($event.target.value)">
                    </div>
                </div>
                <div class="mobi-height">
                    <router-link :to="{ name: 'idea-create'}"
                                 tag="button"
                                 class="button button-create-idea"
                                 @click.native="offSidebar">
                        Предложить свою идею
                    </router-link>
                    <div class="menu-buttons-group">
                        <router-link :to="{ name: 'ideas'}"
                                     class="button"
                                     active-class="is-active"
                                     exact
                                     @click.native="offSidebar">
                            На голосовании
                            <span class="counter">{{ counters.total }}</span>
                        </router-link>
                        <router-link :to="{ name: 'inprocess-ideas'}"
                                     class="button"
                                     active-class="is-active"
                                     @click.native="offSidebar">
                            В работе
                            <span class="counter">{{ counters.inprocess }}</span>
                        </router-link>
                        <router-link :to="{ name: 'completed-ideas'}"
                                     class="button"
                                     active-class="is-active"
                                     @click.native="offSidebar">
                            Реализованные
                            <span class="counter">{{ counters.completed }}</span>
                        </router-link>
                        <router-link v-if="isLogged"
                                     :to="{ name: 'my-ideas'}"
                                     class="button"
                                     active-class="is-active"
                                     @click.native="offSidebar">
                            Мои идеи
                            <span class="counter">{{ counters.my }}</span>
                        </router-link>
                        <router-link v-if="isLogged"
                                     :to="{ name: 'starred-ideas'}"
                                     class="button"
                                     active-class="is-active">
                            Избранные
                            <span class="counter">{{ counters.starred }}</span>
                        </router-link>
                        <router-link v-if="isAdmin"
                                     :to="{ name: 'canceled-ideas'}"
                                     class="button"
                                     active-class="is-active"
                                     @click.native="offSidebar">
                            Отклонённые
                            <span class="counter">{{ counters.canceled }}</span>
                        </router-link>
                        <router-link v-if="isAdmin"
                                     :to="{ name: 'moderation-ideas'}"
                                     class="button"
                                     active-class="is-active"
                                     @click.native="offSidebar">
                            На модерации
                            <span class="counter">{{ counters.moderation }}</span>
                        </router-link>
                    </div>
                    <div class="ideus-mibile"></div>
                </div>
                <user-panel class="user-menu"></user-panel>
            </div>
        </sidebar>

        <sidebar :show="selectedRightSidebar"
                 side="right">
            <header id="right-menu">
                <div class="filter-category">
                    <ul class="filter-menu">
                        <h2 class="title-filter">
                            Фильтр по категориям
                        </h2>

                        <li class="filter-item all-select"
                            :class="{ 'active-item': isCatFilterEmpty()}"
                            @click="setCategory()">
                            <span class="icon-form"></span>Все
                        </li>

                        <li class="filter-item"
                            v-for="cat in rootCategories"
                            :class="{ 'active-item': isCatSelected(cat.id)}"
                            @click="toggleCategory(cat)">
                            <span class="icon-form"></span>
                            {{cat.title}} - {{ counters.categories ? (counters.categories[cat.id] || 0) : '' }}

                            <ul class="sec-menu" v-if="categories[cat.id]">
                                <li class="filter-item"
                                    v-for="child in categories[cat.id]"
                                    :class="{ 'active-item': isCatSelected(child.id)}"
                                    @click="toggleCategory(child)">
                                    <span class="icon-form"></span>
                                    {{child.title}} - {{ counters.categories ? (counters.categories[cat.id] || 0) : '' }}
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </header>
        </sidebar>

        <main id="panel">
            <div id="topbar">
                <router-link to="/ideas/"><img src="/static/logo.png" style="width: 200px;"></router-link>
                <div class="search-block" style="width: 50%">
                    <div class="header-search">
                        <button class="button-search" @click="doSearch">
                            <i class="ti-search"></i>
                        </button>
                        <input v-model="search" type="search" name="search" class="searsh"
                               placeholder="Начать поиск"
                               @click="toggleSearch(true)">
                        <div class="block-search" v-if="showSearch">
                            <div class="similar-title"
                                 v-if="searchResults.byTitle && searchResults.byTitle.length">
                                <p class="similar-theme">Похожие темы</p>
                                <router-link class="similar-block"
                                             :to="{ name: 'idea', params: {id: idea.id}}"
                                             tag="div" v-for="idea in searchResults.byTitle">
                                    <span class="title-similar"><a>{{idea.title}}</a></span>
                                    <span class="button-like cabinet-buttons">
                                        <i class="ti-thumb-up"></i> {{idea.likes}}
                                    </span>
                                    <span class="button-dislike cabinet-buttons">
                                        <i class="ti-thumb-down"></i> {{idea.dislikes}}
                                    </span>
                                    <p class="user-name">{{dateNoTime(idea.created)}}</p>
                                </router-link>
                            </div>
                            <div class="similar-text"
                                 v-if="searchResults.byDesc && searchResults.byDesc.length">
                                <p class="similar-theme">Упоминания в тексте</p> <br/>
                                <router-link :to="{ name: 'idea', params: {id: idea.id}}" class="similar-text-content" v-for="idea in searchResults.byDesc">
                                    <div class="title">{{ idea.title }}</div>
                                    <div class="desc">{{ idea.description | striphtml }}</div>
                                </router-link>
                            </div>
                            <div v-if="searchResults.byTitle && searchResults.byDesc && !searchResults.byTitle.length && !searchResults.byDesc.length">
                                <p>
                                    <em>Ничего не найдено</em>
                                </p>
                            </div>
                            <span class="bautton-similar"
                                  v-if="searchResults.byTitle && searchResults.byDesc && searchResults.byTitle.length && searchResults.byDesc.length"><router-link
                                    :to="{ name: 'search', params: {term: search} }">Смотреть все результаты</router-link></span>
                        </div>
                    </div>
                </div>
                <div class="mobi-height">
                        <router-link :to="{ name: 'idea-create'}"
                                     tag="button"
                                     class="button">
                            Предложить свою идею
                        </router-link>
                    <div class="ideus-mibile"></div>
                </div>
                <user-panel class="user-menu"></user-panel>
            </div>
            <div class="header-mobile">
               <span class="menu-sandwich" @click="selectedLeftSidebar = !selectedLeftSidebar">
                    <span class="sandwich"></span>
               </span>
                <router-link to="/ideas/" class="widgets-ideas-button all-ideas">Все идеи</router-link>
                <span class="set" @click="selectedRightSidebar = !selectedRightSidebar">
                    <i class="ti-filter" aria-hidden="true"></i>
                </span>
            </div>

            <main class="main" @click="toggleSearch(false); offSidebar()">
                <router-view></router-view>
            </main>
        </main>

        <spinner size="large" message="Загрузка..."></spinner>
        <informator :show="showInfo"></informator>

        <footer>
            <div class="container footer-block">
                <p class="footer-copyright">© 2017 «Платформа LP». Все права защищены.</p>
                <p class="footer-socials">
                    <a href="https://vk.com/platformalp" class="socials-link" target="_blank">
                        <img src="/static/socials/vkontakte@2x.png"/>
                    </a>
                    <a href="https://www.facebook.com/weloveplatformalp/" class="socials-link" target="_blank">
                        <img src="/static/socials/facebook@2x.png"/>
                    </a>
                    <a href="https://t.me/platformalp" class="socials-link" target="_blank">
                        <img src="/static/socials/telegram@2x.png"/>
                    </a>
                    <a href="https://www.instagram.com/platforma_lp/" class="socials-link" target="_blank">
                        <img src="/static/socials/instagram@2x.png"/>
                    </a>
                    <a href="https://www.youtube.com/channel/UCbqmPnagvp3CF43XnlsQEqw" class="socials-link" target="_blank">
                        <img src="/static/socials/youtube@2x.png"/>
                    </a>
                    <a href="https://plus.google.com/u/1/114447428233574103343" class="socials-link" target="_blank">
                        <img src="/static/socials/googleplus@2x.png"/>
                    </a>
                    <a href="https://twitter.com/platformalp" class="socials-link" target="_blank">
                        <img src="/static/socials/twitter@2x.png"/>
                    </a>
                </p>
            </div>
        </footer>
    </v-touch>

</template>

<script>
    import Sidebar from './components/Sidebar'

    let lastRoute = null;

    export default {
        name: 'app',
        components: {
            'sidebar': Sidebar
        },
        data () {
            return {
                enteredSearchString: '',
                selectedLeftSidebar: false,
                selectedRightSidebar: false
            };
        },
        computed: {
            isLogged() {
                return this.$store.state.auth.isLogged;
            },
            isAdmin() {
                return this.$store.getters['auth/isAdmin'];
            },
            showInfo() {
                return this.$store.state.showInfo
            },
            search: {
                get() {
                    return this.$store.state.search
                },
                set(value) {
                    this.$store.commit('SET_SEARCHTERM', value);
                    // if (value.length > 2) {
                        this.doSearch(value);
                    // }
                }
            },
            counters() {
                return this.$store.state.ideas.counters;
            },
            showSearch() {
                return this.$store.state.showSearch
            },

            searchResults() {
                return this.$store.state.searchResults
            },

            rootCategories() {
                return this.$store.state.ideas.rootCategories
            },

            categories() {
                return this.$store.state.ideas.categoriesByParentId
            }
        },

        mounted() {
            // var self = this;
            // window.document.addEventListener ("keyup", function (zEvent) {
            //
            //   if (zEvent.code == 'Escape' && zEvent.srcElement.id == 'searchInput') {
            //     self.toggleSearch(false);
            //   }
            //   if (zEvent.altKey && (zEvent.code === "KeyF" || zEvent.code === 'KeyS')) {
            //     self.toggleSearch(true);
            //     return false;
            //   }
            // } );


            this.$store.dispatch('ideas/loadCategories');

        },

        methods: {
            toggleSearch (flag) {
                if (flag && !this.search) { return false; }

                this.$store.dispatch('toggleSearch', flag).then(function () {
                    if (flag) {
                        setTimeout(function () {
                            // window.document.getElementById('searchInput').select()
                        }, 100)
                    }
                })
            },

            toggleSwipeSidebar (direction) {
                // TODO: Нужно подумать как сделать это лучше
                if (document.body.clientWidth >= 992) {
                    return this.offSidebar();
                }
                if (direction === 'left') {
                    if (this.selectedLeftSidebar) {
                        this.selectedLeftSidebar = false;
                    } else {
                        this.selectedRightSidebar = true;
                    }
                }
                if (direction === 'right') {
                    if (this.selectedRightSidebar) {
                        this.selectedRightSidebar = false;
                    } else {
                        this.selectedLeftSidebar = true;
                    }
                }
            },

            offSidebar () {
                this.selectedLeftSidebar = false;
                this.selectedRightSidebar = false;
            },

            doSearch (search) {
                this.$store.dispatch('doSearch', search).then((data) => {
                    this.$store.dispatch('toggleSearch', true);
                })
            },
            enterSearchString (value) {
                this.enteredSearchString = value;
            },
            goToSearch (value) {
                this.selectedLeftSidebar = false;
                this.$router.push({
                    name: 'search',
                    params: { term: value }
                });
            },
            isCatFilterEmpty() {
                return !(this.$store.state.ideas.query.categories.length > 0);
            },

            isCatSelected(categoryId) {
                return !!~this.$store.state.ideas.query.categories.indexOf(categoryId);
            },
            toggleCategory(category) {
                this.$store.dispatch('ideas/queryToggleCategory', category.id)
            },

            setCategory(categoryId) {
                this.$store.dispatch('ideas/querySetCategory', categoryId)
            }
        }
    };
</script>


<style lang="scss">
    @import './styles/global';
    @import "./styles/_settings.scss";

    $left-bar-color: #F0F0F0;

    html, body {
        font-size: 14px;
        height: 100%;
    }

    #app {
        position: relative;
        min-height: 100%;
        overflow-x: hidden;
        touch-action: pan-y pinch-zoom !important;
        user-select: auto !important;
    }

    [contenteditable] {
        -webkit-user-select: text;
        user-select: text;
    }

    .button-bar .button {
        margin-bottom: 0;
    }

    .menu li, .menu a {
        cursor: pointer;
    }

    .menu li.is-active, .menu li.is-active:hover {
        background-color: $menu-item-background-active;
    }

    .menu li:hover {
        background-color: $menu-item-background-hover;
    }

    .button-bar {
        background-color: #fff;
        button {
            margin-bottom: 0
        }
    }

    #searchPanel {
        position: fixed;
        padding: 1em;
        top: 0;
        width: calc(100% - 4em);
        background: $left-bar-color;
        margin-left: 3.9em;
    }

    .search-enter-active, .search-leave-active {
        transition: opacity .15s
    }

    .search-enter, .search-leave-to {
        opacity: 0
    }

    .padding {
        padding: 1em 1.5em;
    }

    #loading {
        position: fixed;
        z-index: 9999;
        background: rgba(255, 255, 255, 0.7);
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .small {
        font-size: 80%
    }

    /* переносить текст по словам */
    pre, .vex-dialog-message {
        white-space: pre-wrap; /* Since CSS 2.1 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -pre-wrap; /* Opera 4-6 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .tooltip {
        max-width: 20rem;
    }

    .tabs {
    }

    .tabs-title > a {
        font-size: 0.95rem;
    }

    .tabs-title.is-active > a {
        background: $tab-background-active;
        /*background: #ffffff;*/
        color: $tab-active-color;
    }

    .tabs.subtabs .tabs-title > a {
        padding: 0.8rem 1.25rem
    }

    td .icon {
        color: #979797;
        font-size: 140%;
        padding: 0.5em 0;
        vertical-align: middle;
    }

    .icon.grey {
        color: #979797;
    }

    .icon.red {
        color: orangered;
    }

    .icon.green {
        color: limegreen;
    }

    .pink {
        color: lightpink;
    }

    td .button-group, td .button {
        margin: 0;
    }

    button:focus {
        outline: none;
    }

    .button.alt {
        border: none;
        font-size: 1.1rem;
        padding: 0.5em 0.6em;
        background: transparent;

        &:hover, &:focus {
            border: none;
            background: #F0F0F0;
            outline: none;
        }
    }

    .button-create-idea {
        display: block;
        width: 80%;
        margin: 0 auto;
    }

    .v--modal-box {
        overflow: scroll !important;
    }

    /*
      .button {
        @include button-style($light-gray, #01C764, $button-color-alt);
      }
    */

    #maingrid {
        height: 100vh;
    }

    #mainbody {
        overflow-y: scroll;
        position: relative;
    }

    #leftbar {
        background: $left-bar-color;

        #left-menu a {

            text-align: center;
            border-bottom: 1px #CDCDCD solid;
            border-top: 1px #F3F3F3 solid;

            &:hover {
                background: #CDCDCD;
                border-top: 1px #CDCDCD solid;
            }
        }
    }

    /* Chrome Reset */
    a:focus {
        outline: none;
    }

    .logo, .logo a {
        color: $white;
        font-weight: normal;
    }

    li a.menu-button {
        border-radius: 20px;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        font-weight: 600;
        text-transform: uppercase;
        display: inline-block;
        float: right;
    }

    .content-wrapper {
        padding: 0.75rem 0;
    }

    /*
      .sidebar-menu {
        @include menu-base();
        @include menu-direction(vertical);
        a {
          color: $secondary-color;
          font-weight: normal;
        }
        a.active {
          font-weight: 600;
          color: $primary-color;
        }
      }
    */

    table input, table select {
        margin: 0 !important;
    }

    .slim-inputs input {
        padding: 0;
        border: 0;
        background: transparent;
        border-bottom: 1px $medium-gray solid;
        box-shadow: none;
        height: auto;
        outline: none;
        margin: 0
    }

    .slim-inputs input:focus {
        border: 0;
        border-bottom: 1px $dark-gray solid;
        box-shadow: none;

    }

    .slim-inputs select {
        margin: 0;
    }

    #panel {
        background: #f5f8fa;
        width: 100%;
        padding-bottom: 120px;
    }

    a.similar-text-content {
        color:rgb(41, 43, 44);
    }
</style>



// WEBPACK FOOTER //
// App.vue?1e28bf9a